<template>
  <div :class="tabClasses">
    <ul class="flex" :class="listClasses">
      <template v-for="(tab, index) in tabs">
        <li
          :key="index"
          tabindex="0"
          @focus="onFocus(index)"
          @focusout="onFocusout()"
          @click="onClick(index)"
          @keyup.enter="onClick(index)"
          class="focus:outline-none py-4 lg:py-6 px-4 lg:px-30px rounded-t-10px duration-300 text-center"
          :class="[itemClasses, { 'bg-white': isActive(index), 'focus:bg-white': isFocused(index) && isActive(index), 'focus:bg-white': isFocused(index) }]"
          v-if="$scopedSlots[tab.name]"
        >
          <slot :focused="isFocused(index)" :active="isActive(index)" :label="tab.label">
            <div
              v-if="tab.icon"
              class="w-36px h-36px inline-flex items-center justify-center rounded-full bg-blue-100"
              :class="{
                'bg-blue-100' : isActive(index),
                'bg-white' : !isActive(index)
              }"
            >
              <span
                :class="[
                  `icon-${tab.icon}`,
                  {
                    'text-blue-700 ' : isActive(index),
                    'text-blue-300 ' : !isActive(index),
                  }
                ]"
              ></span>
            </div>
            <span
              class="tab-toggle block cursor-pointer text-h4 font-medium font-title my-1.5"
              :class="{
                'text-blue-900 ' : isActive(index),
                'text-white ' : !isActive(index),
              }"
            >{{ tab.label }}</span>
            <span
              v-if="tab.baseline"
              class="text-body-2"
              :class="{
                'text-blue-500 ' : isActive(index),
                'text-blue-200 ' : !isActive(index),
              }"
            >{{ tab.baseline }}</span>
          </slot>
        </li>
      </template>
    </ul>
    <div class="relative rounded-b-20px">
      <template v-for="(tab, index) in tabs">
        <transition name="tabs" :key="index">
          <div class="duration-300 max-w-full top-0" :class="contentClasses" v-if="isActive(index)">
            <slot :name="tab.name"></slot>
          </div>
        </transition>
      </template>
    </div>
  </div>
</template>

<script>
import eventHub from '../helpers/event-hub'

export default {
  data() {
    return {
      focused: null
    };
  },
  computed: {
    activeTab: {
      get() {
        return this.active;
      },
      set(index) {
        this.$emit('update:active', index);
      },
    },
  },
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
    active: {
      type: Number,
      default: 0
    },
    tabClasses: {
      type: [String, Array, Object],
      default: ''
    },
    listClasses: {
      type: [String, Array],
      default: 'border-b-2'
    },
    itemClasses: [String, Array],
    contentClasses: [String, Array],
  },
  methods: {
    onClick(index) {
      this.activeTab = index;
      this.$emit('change', index)
    },
    onFocus(index) {
      this.focused = index;
    },
    onFocusout() {
      this.focused = null;
    },
    isActive(index) {
      return this.activeTab === index;
    },
    isFocused(index) {
      return this.focused === index;
    },
  },
};
</script>

<style scoped>
/* purgecss start ignore */
.tab-toggle {
  margin-bottom: -2px;
}
.tabs-enter, .tabs-leave-to /* .scale-leave-active below version 2.1.8 */ {
  @apply opacity-0 absolute;
}
/* purgecss end ignore */
</style>
